import Call from "@/components/Call";
import Container from "@/components/Container";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import useCollectionById from "@/hooks/collectionOrder/useCollectionById";
import useTransactions from "@/hooks/collectionOrder/useTransactions";
import React from "react";
import { useParams } from "react-router-dom";
import ActivityLogCard, { Transaction } from "./ActivityLogCard";
import AttachmentCard from "./AttachmentCard";
import { ChevronRight } from "lucide-react";

type Props = {};

const CollectionDetail = (props: Props) => {
  const { id } = useParams();

  const {
    Customer,
    Collector,
    CreatedBy,
    amount,
    loading: loadingColections,
  } = useCollectionById(id as string);
  const { transactions, loading: loadingTransactions } = useTransactions(
    id as string
  );

  let collect: any[] = [];
  let deposit: any[] = [];

  // extraact files into a attachemnts variable from transactions
  transactions.map((transaction: any) => {
    if (transaction.type === "collect") {
      collect.push(transaction);
    } else {
      deposit.push(transaction);
    }
    return null;
  });

  return (
    <Container>
      <div className="h-screen flex gap-4 flex-col p-6  overflow-hidden">
        {/* top */}
        <div className="flex items-center gap-4">
          <h1 className="font-semibold text-[18px]">
            Collection orders detail
          </h1>
          <Call customer={Customer} />
        </div>

        <div className="flex flex-col gap-4 pl-8 pr-32">
          {/* collection info */}
          <div className="flex flex-col gap-4  ">
            <div className="flex gap-8 w-full">
              <div className="flex flex-col gap-2 w-1/2">
                <Label>Customer name</Label>
                <Input
                  value={Customer?.commercial_name}
                  disabled
                  className="mr-4"
                />
              </div>
              <div className="flex flex-col gap-2 w-1/2">
                <Label>Collector name</Label>
                <Input value={Collector?.fullname} disabled className="mr-4" />
              </div>
            </div>
            <div className="flex gap-8 w-full">
              <div className="flex flex-col gap-2 w-1/2">
                <Label>Amount</Label>
                <div className="relative">
                  <Input
                    value={amount}
                    disabled
                    className="pr-12 text-primary" // Add padding to the right for the DZD text
                  />
                  <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                    DZD
                  </span>
                </div>
              </div>

              <div className="flex flex-col gap-2 w-1/2">
                <Label>Created by</Label>
                <Input value={CreatedBy?.fullname} disabled className="mr-4" />
              </div>
            </div>
          </div>

          {/* collection attachtments */}
          <div className="flex flex-col gap-4">
            <h2 className="font-medium text-[16px]">Attachments</h2>
            <div className="flex gap-8 items-center">
              <div className="flex gap-4 overflow-x-auto w-[700px] ">
                {collect.map((item: any) => (
                  <AttachmentCard key={item.id} item={item} />
                ))}
                {deposit.map((item: any) => (
                  <AttachmentCard key={item.id} item={item} />
                ))}
              </div>
              {/* <ChevronRight className="h-12 w-12 text-primary" /> */}
            </div>
          </div>

          {/* activty log */}

          <div className="flex flex-col gap-4 ">
            <h2 className="font-medium text-[18px]">Activity Log</h2>
            <div className="flex flex-col gap-4  overflow-y-scroll h-[280px]">
              {transactions?.map((transaction: any) => (
                <ActivityLogCard
                  key={transaction.id}
                  type={transaction.type}
                  transaction={transaction}
                  Customer={Customer}
                  Collector={Collector}
                  CreatedBy={CreatedBy}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default CollectionDetail;
